import type * as gql from "@medbillai/graphql-types";

import { formatDefaultDate } from "@medbillai/ui";

import type { Person } from "./types";

export const personFullName = (
  person: Pick<Person, "givenNames" | "familyName"> | undefined,
): string => {
  if (!person) {
    return "";
  }
  const names = [...(person.givenNames ?? []), person.familyName].filter(
    Boolean,
  );
  return names.join(" ");
};

export const templateFormFieldsUser = (person: gql.Person) => {
  return {
    "u-firstName": person.givenNames?.join(" ") ?? undefined,
    "u-lastName": person.familyName ?? undefined,
    "u-fullName": personFullName(person),
    "u-dob": formatDefaultDate(person.dateOfBirth) ?? undefined,
  };
};

export const newPerson: Person = {
  id: "new_person",
  givenNames: ["New Person"],
  dateOfBirth: "1985-10-15",
  primary: false,
};
